import { Alert, AlertType } from '@toggle/design-system';
import React from 'react';

interface SourcesUpdateAlertProps {
  type: AlertType;
  message: string;
}

export const SourcesUpdateAlert = ({
  type,
  message,
}: SourcesUpdateAlertProps) => {
  return <Alert type={type} title={message} />;
};
